'use strict';

import type { IndPolicyAccVal } from '../../Entities/Ind/IndPolicyAccVal';
import { EntityCollection } from '../EntityCollection';

export class IndPolicyAccValCollection extends EntityCollection<IndPolicyAccVal> {}
